
import { FormState__setValidationResponse_5219762A, FormState__startLoading, ProtocolConfiguration as ProtocolConfiguration_2, ProtocolVisibleFields, FormState_get_empty, RequestedValue$1 } from "../../../Shared/Shared.js";
import { Msg, State } from "./Types.js";
import { Cmd_none, Cmd_batch } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { updateProtocolConfiguration, getCustomerConfiguration } from "../../../Requests/Configuration.js";
import { ofArray, singleton } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Cmd_successToast, Cmd_errorToast } from "../../../Components/Toast.js";

export const initialState = new State(new RequestedValue$1(0, []), new RequestedValue$1(0, []), FormState_get_empty());

export function init() {
    return [initialState, Cmd_batch(singleton(getCustomerConfiguration((Item) => (new Msg(2, [Item])), (Item_1) => (new Msg(5, [Item_1])))))];
}

export function update(msg, state) {
    switch (msg.tag) {
        case 1: {
            const matchValue_1 = state.ProtocolConfiguration;
            if (matchValue_1.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                const protocolConfiguration_1 = matchValue_1.fields[0];
                return [new State(state.CustomerConfiguration, new RequestedValue$1(1, [new ProtocolConfiguration_2(protocolConfiguration_1.ImageUrl, new ProtocolVisibleFields(protocolConfiguration_1.ProtocolVisibleFields.QrCodeIds, msg.fields[0]))]), state.FormState), Cmd_none()];
            }
        }
        case 3: {
            const matchValue_2 = state.ProtocolConfiguration;
            if (matchValue_2.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                return [new State(state.CustomerConfiguration, state.ProtocolConfiguration, FormState__startLoading(state.FormState)), updateProtocolConfiguration(matchValue_2.fields[0], (Item) => (new Msg(4, [Item])), (Item_1) => (new Msg(5, [Item_1])))];
            }
        }
        case 2: {
            const response = msg.fields[0];
            return [new State(new RequestedValue$1(1, [response]), new RequestedValue$1(1, [response.ProtocolConfiguration]), state.FormState), Cmd_none()];
        }
        case 4: {
            const response_1 = msg.fields[0];
            if (response_1.tag === 1) {
                return [new State(state.CustomerConfiguration, state.ProtocolConfiguration, FormState__setValidationResponse_5219762A(state.FormState, response_1.fields[0])), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(state.CustomerConfiguration, state.ProtocolConfiguration, FormState_get_empty()), Cmd_batch(ofArray([Cmd_successToast("general.saved_successfully"), getCustomerConfiguration((Item_2) => (new Msg(2, [Item_2])), (Item_3) => (new Msg(5, [Item_3])))]))];
            }
        }
        case 5:
            return [new State(state.CustomerConfiguration, state.ProtocolConfiguration, FormState_get_empty()), Cmd_none()];
        default: {
            const matchValue = state.ProtocolConfiguration;
            if (matchValue.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                const protocolConfiguration = matchValue.fields[0];
                return [new State(state.CustomerConfiguration, new RequestedValue$1(1, [new ProtocolConfiguration_2(protocolConfiguration.ImageUrl, new ProtocolVisibleFields(msg.fields[0], protocolConfiguration.ProtocolVisibleFields.EntityImage))]), state.FormState), Cmd_none()];
            }
        }
    }
}

